import React, { useState, useEffect } from "react";
import { Box, useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import { useNavigate } from "react-router-dom";
import { purchasesColumns } from "./config";
import { dataGridStyles, localeText } from "../../utils/dataGridConfig";
import ErrorComponent from "../../components/ErrorComponent";
import SearchFilter from "../../components/SearchComponent";
import { useGetPurchasesQuery } from "../../services/inventoryService";

const Purchases = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState("");
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });

  // Fetch data with pagination and search term
  const { data: purchases, error, isLoading, refetch } = useGetPurchasesQuery({
    offset: paginationModel.page * paginationModel.pageSize,
    limit: paginationModel.pageSize,
    number: searchTerm, // Use search term
  });

  // Re-fetch data when paginationModel or searchTerm changes
  useEffect(() => {
    refetch();
  }, [paginationModel, refetch, searchTerm]);

  const handleView = async (id) => {
    navigate(`${window.location.pathname}/view/${id}`);
  };

  const columns = purchasesColumns(handleView, colors);

  if (error) {
    return <ErrorComponent />;
  }

  return (
    <Box m="20px">
      <Header title="Compras" subtitle="Lista de compras" showCreateButton={true} />

      {/* Filter Section */}
      <Box
        display="grid"
        gap="30px"
        gridTemplateColumns="repeat(12, minmax(0, 1fr))"
      >
        {/* Search Filter */}
        <Box sx={{ gridColumn: "span 2" }}>
          <SearchFilter
            onSearchChange={(term) => setSearchTerm(term)} // Pass search term to state
            label="Número de Factura"
          />
        </Box>
      </Box>

      <Box sx={dataGridStyles(colors)} height="75vh">
        <DataGrid
          columns={columns}
          rows={purchases?.records || []}
          rowCount={purchases?.count || 0}
          loading={isLoading}
          pagination
          paginationModel={paginationModel}
          rowsPerPageOptions={[10, 20, 50]}
          pageSizeOptions={[10, 20, 50]}
          paginationMode="server"
          onPaginationModelChange={(newPaginationModel) => {
            setPaginationModel(newPaginationModel);
          }}
          loadingText="Cargando..."
          localeText={localeText}
          disableRowSelectionOnClick
          disableColumnMenu
          disableColumnSorting
        />
      </Box>
    </Box>
  );
};

export default Purchases;